import { render, staticRenderFns } from "./ReviewDetailsNew.vue?vue&type=template&id=30d3381a&scoped=true"
import script from "./ReviewDetailsNew.vue?vue&type=script&lang=ts"
export * from "./ReviewDetailsNew.vue?vue&type=script&lang=ts"
import style0 from "./ReviewDetailsNew.vue?vue&type=style&index=0&id=30d3381a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d3381a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d3381a')) {
      api.createRecord('30d3381a', component.options)
    } else {
      api.reload('30d3381a', component.options)
    }
    module.hot.accept("./ReviewDetailsNew.vue?vue&type=template&id=30d3381a&scoped=true", function () {
      api.rerender('30d3381a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reviews/ReviewDetailsNew.vue"
export default component.exports